"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var common_hooks_1 = require("@l2p/common-hooks");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var YouParticipate_1 = __importDefault(require("../../../classic/YouParticipate"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var Content = function (_a) {
    var id = _a.id, title = _a.title, description = _a.description, endDate = _a.endDate, me = _a.me, isFinished = _a.isFinished;
    var t = (0, next_intl_1.useTranslations)('translation');
    var isUserParticipate = (0, react_1.useMemo)(function () {
        return !!me;
    }, [me]);
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var time = (0, common_hooks_1.useTimer)({ endDate: endDate }).time;
    var isFinishedByDate = endDate ? new Date(endDate) < new Date() : false;
    var _b = (0, swr_hooks_1.useJoinTournament)(), joinTournament = _b.joinTournament, isSubmitting = _b.isSubmitting;
    var signUpNavigate = (0, apps_shared_1.useOpenSignUp)();
    var participate = (0, react_1.useCallback)(function (id) {
        if (!isAuth)
            return signUpNavigate();
        if (id)
            joinTournament({ id: id });
    }, [joinTournament, signUpNavigate, isAuth]);
    if (isFinishedByDate)
        return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.firstTitle }, t('tournament')),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, description),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.finished }, t('finished')))));
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("div", { className: styles_module_scss_1.default.firstTitle }, t('tournament')),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.title }, title),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, description),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.participateContainer }, !isUserParticipate ? (!isFinished ? (react_1.default.createElement(ui_components_1.FixedButton, { color: "gradient", className: "participate", height: breakpoints.mobile ? '32px' : '48px', onClick: function () {
                    participate(id);
                }, loading: isSubmitting },
                t('joinNow'),
                react_1.default.createElement("section", null,
                    react_1.default.createElement("span", null, t('timeLeft')),
                    " ",
                    time.days,
                    ":",
                    time.hours,
                    ":",
                    time.minutes,
                    ":",
                    time.seconds))) : null) : (react_1.default.createElement(YouParticipate_1.default, null))))));
};
exports.default = Content;
